module.exports = __webpack_public_path__ + "img/assoc_ris_task_prjweb.72af5c8b.png";